<svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 32 32">

    <path
        d="M16,0A16.05,16.05,0,0,1,32,16C31.17,37.32.82,37.32,0,16A16.05,16.05,0,0,1,16,0Zm7.41,18.22a1.52,1.52,0,0,1,1.26,2,8.53,8.53,0,0,1-1.6,2,10.08,10.08,0,0,1-8,2.92,10.56,10.56,0,0,1-7.44-4.47A1.55,1.55,0,0,1,7.41,19a1.51,1.51,0,0,1,1.95-.65c.65.31.91,1,1.42,1.51a7.1,7.1,0,0,0,11.26-1A1.5,1.5,0,0,1,23.41,18.22ZM11,9.52a2.51,2.51,0,0,1,0,5A2.51,2.51,0,0,1,11,9.52Zm10,0a2.51,2.51,0,0,1,0,5A2.51,2.51,0,0,1,21,9.52Z"
        style="fill-rule:evenodd" />
</svg>
